/**
 * @preserve
 * Licenses of bundled dependencies can be found in dependencies-licenses.txt
 */
var monkeyPatch=function(n,e,o,t){var i="__wb__"+e;n[i]=n[e];n[e]=function(){var e=function(){n[i]();if(t){t()}};if(o){new Promise((function(n){return o(n)})).then(e)}else{e()}}};export{monkeyPatch as m};
//# sourceMappingURL=monkey-patch-cb82c679.js.map